import { render, staticRenderFns } from "./OrderMailTag.vue?vue&type=template&id=770705ee&scoped=true"
import script from "./OrderMailTag.vue?vue&type=script&lang=js"
export * from "./OrderMailTag.vue?vue&type=script&lang=js"
import style0 from "./OrderMailTag.vue?vue&type=style&index=0&id=770705ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770705ee",
  null
  
)

export default component.exports